import type {
  PricingSectionSliceModulesAndAddonsPrimaryModulesHeaderItem,
  PricingSectionSliceModulesAndAddonsPrimaryModulesItem,
} from 'prismicio-types'
import {ModuleCard} from './ModuleCard'
import {SectionHeader} from './SectionHeader'

type ModulesSectionProps = {
  header?: PricingSectionSliceModulesAndAddonsPrimaryModulesHeaderItem
  modules: PricingSectionSliceModulesAndAddonsPrimaryModulesItem[]
}

export const ModulesSection = ({header, modules}: ModulesSectionProps) => {
  if (!header) {
    return null
  }

  return (
    <div className="flex flex-col gap-12">
      <SectionHeader
        eyebrow={header.eyebrow}
        heading={header.heading}
        description={header.description}
        smallerFontSize={header.smaller_font_size}
      />

      {modules.length > 0 && (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {modules.map((module, index) => (
            <ModuleCard key={`module-${index}`} module={module} index={index} />
          ))}
        </div>
      )}
    </div>
  )
}
